import { useCallback, useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";

function extractErrorMessage(data) {
  if (!data) return "We could not load the dashboard.";
  if (typeof data.message === "string") return data.message;
  if (data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).flat()[0];
    if (typeof first === "string") return first;
  }
  return "We could not load the dashboard.";
}

export function useDashboardViewModel(logout) {
  const [summary, setSummary] = useState(null);
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  const refresh = useCallback(
    async (from, to) => {
      setLoading(true);
      setFetchError(null);

      const qs = new URLSearchParams({ from, to }).toString();

      const [summaryResult, activityResult] = await Promise.all([
        makeGetApiCall(`operations-dashboard/summary?${qs}`),
        makeGetApiCall(`operations-dashboard/activity?${qs}`),
      ]);

      let errorParts = [];

      if (summaryResult.success) {
        setSummary(summaryResult.data);
      } else {
        setSummary(null);
        if (summaryResult.errorStatus === 401) {
          logout?.();
        }
        errorParts.push(extractErrorMessage(summaryResult.data));
      }

      if (activityResult.success) {
        setActivity(activityResult.data);
      } else {
        setActivity(null);
        if (activityResult.errorStatus === 401) {
          logout?.();
        }
        errorParts.push(extractErrorMessage(activityResult.data));
      }

      if (errorParts.length) {
        setFetchError([...new Set(errorParts)].join(" "));
      }

      setLoading(false);
    },
    [logout]
  );

  return {
    summary,
    activity,
    loading,
    fetchError,
    refresh,
  };
}
